import * as ng from 'angular';
import * as _ from 'lodash-es';
import {IDocsAndFolders} from "../../types/Common";
import {ISearchV2Response} from "../../types/SearchTypes";

export interface IRecentSharedService {
    getRecentlySharedDocsAndFolders: () => ng.IPromise<IDocsAndFolders>
}

angular.module('GorillaBoy.Dboard')
    .factory('RecentSharedService', [
        '$log',
        '$q',
        'SortService',
        'SearchV2Service',
        function ($log: ng.ILogService, $q: ng.IQService, SortService: any, SearchV2Service: any) {
            var RecentSharedService: IRecentSharedService = {
                getRecentlySharedDocsAndFolders: function () {
                    return $q.all([
                        SearchV2Service.searchResources(null, {
                                orderBy: "MODIFIED_TIMESTAMP",
                                order: SortService.CONSTANTS.ORDER.DESCENDING
                            },
                            {SharedWithMe: true, Types: ["DOCUMENT"]}, null, null) as ng.IPromise<any>,
                        SearchV2Service.searchResources(null, {
                                orderBy: "MODIFIED_TIMESTAMP",
                                order: SortService.CONSTANTS.ORDER.DESCENDING
                            },
                            {SharedWithMe: true, Types: ["FOLDER"]}, null, null) as ng.IPromise<any>
                    ])
                        .then(function (response: any) {
                            let documents = [], folders = [];
                            const data: ISearchV2Response = response[0].data;
                            if (data.Documents) {
                                documents = data.Documents;
                            }
                            documents = _.uniqBy(documents, 'Id');

                            const data2: ISearchV2Response = response[1].data;
                            if (data2.Folders) {
                                folders = data2.Folders;
                            }
                            folders = _.uniqBy(folders, 'Id');
                            return ({
                                folders,
                                documents
                            });
                        });
                }
            };
            return RecentSharedService;
        }]);
